import { getToken, isTokenExpired, isRole } from "@/common/http-common";
import { ACCESS_TOKEN } from "@/properties/close-friend";

export function checkPathAndGoNext(to, next) {
  if (to.fullPath && to.fullPath.substr(0, 2) === "/#") {
    const path = to.fullPath.substr(2);
    next(path);
    return;
  }
  if (to.path && to.path.startsWith('/creator')) {
    const token = getToken(ACCESS_TOKEN);
    if (!token || isTokenExpired(ACCESS_TOKEN) || !isRole('INFLUENCER')) {
      return next({ name: 'LoginMobile', query: { redirect: to.fullPath } });
    }
  }
  next();
}
